import React from "react";
import { FaTshirt, FaIndustry, FaHotel, FaStar, FaCogs, FaCheck, FaCheckCircle } from "react-icons/fa";

const combinedData = {
  expertiseData: [
    {
      icon: FaTshirt,
      title: "Corporate Wear",
      desc: "Polished and comfortable apparel designed for the modern workplace.",
      points: [
        "Corporate T-Shirts, polos, shirts, and blazers",
        "Blended fabrics for durability and style",
        "Custom branding through embroidery and prints",
      ],
    },
    {
      icon: FaIndustry,
      title: "Industrial & Safety Wear",
      desc: "Durable and protective apparel built for challenging environments.",
      points: [
        "Coveralls, hi-vis jackets, flame-retardant uniforms",
        "Healthcare scrubs, lab coats, and specialized safety gear",
        "Designed for functionality and compliance",
      ],
    },
    {
      icon: FaHotel,
      title: "Hospitality & Service Apparel",
      desc: "Elegant, functional uniforms for front-line and back-end staff.",
      points: [
        "Chef coats, aprons, waistcoats, and housekeeping uniforms",
        "Reception and guest-facing attire for hotels and restaurants",
        "Easy-maintenance fabrics with stylish cuts",
      ],
    },
    {
      icon: FaStar,
      title: "Promotional & Event Apparel",
      desc: "Custom-branded clothing that makes your brand stand out.",
      points: [
        "Event T-Shirts, jerseys, polos, and hoodies",
        "Custom colors, logos, and limited-edition collections",
        "Perfect for campaigns, launches, and team events",
      ],
    },
    {
      icon: FaCogs,
      title: "Customized Solutions",
      desc: "Tailor-made apparel designed exclusively for your brand.",
      points: [
        "Personalized fits, fabrics, and finishing",
        "Embroidery, screen printing, and digital printing",
        "End-to-end consultation to bring your vision to life",
      ],
    },
  ],
  qualityPoints: [
    "Fabric Testing – Strength, softness, and colorfastness",
    "Stitching Checks – Durability and precision",
    "Size & Fit Consistency – Uniformity across bulk orders",
    "Print & Embroidery Inspection – Clarity, sharpness, and lasting finish",
    "Final Packaging Audit – Clean, professional, and ready for delivery",
  ],
};

const Whatwedo = () => {
  const { expertiseData, qualityPoints } = combinedData;

  return (
    <section className="py-16 px-6 md:px-12 lg:px-20 relative bg-[#F6AE1B] mt-10">
      
      <div className="text-center max-w-4xl mx-auto space-y-6">
        <h1 className="text-4xl md:text-5xl font-extrabold text-black">
          What <span className="text-white">We Do</span>
        </h1>
        <p className="text-black text-base md:text-lg leading-relaxed">
          At Dheeram Apparel Creations, we believe apparel is more than just clothing — it is a statement of brand identity, professionalism, and trust. With our corporate office in Chennai and advanced manufacturing unit in Tiruppur, we provide comprehensive apparel solutions for businesses across industries.
        </p>
      </div>

      <div className="flex items-center justify-center my-5">
        <div className="border-t border-black w-1/2"></div>
        <span className="mx-4 text-white text-xl">★</span>
        <div className="border-t border-black w-1/2"></div>
      </div>

    
      <div className="max-w-5xl mx-auto text-center mb-12">
        <h2 className="text-4xl md:text-5xl font-extrabold text-black">
          Our <span className="text-white">Expertise</span>
        </h2>
        <p className="text-black text-base md:text-lg mt-4 leading-relaxed">
          We provide specialized apparel solutions across industries to ensure your brand stands out.
        </p>
      </div>

      <div className="relative">
      
        <div className="hidden md:block absolute top-0 left-1/2 transform -translate-x-1/2 w-1 h-full bg-black/30"></div>

       {expertiseData.map((item, idx) => {
  const Icon = item.icon;
  const isEven = idx % 2 === 0;

  return (
    <div key={idx} className="relative mb-20">
      {/* 1. The Central Icon (Fixed in the middle) */}
      <div className="absolute left-1/2 transform -translate-x-1/2 z-20">
        <div className="bg-black w-14 h-14 md:w-16 md:h-16 rounded-full flex items-center justify-center text-white text-2xl shadow-lg border-4 border-[#F6AE1B]">
          <Icon />
        </div>
      </div>

      {/* 2. The Content Wrapper */}
      <div className="grid grid-cols-1 md:grid-cols-2 w-full">
        
        {/* Left Side Container */}
        <div className={`px-6 md:px-12 flex flex-col ${isEven ? "md:items-end md:text-right" : "hidden md:block opacity-0"}`}>
          {isEven && (
            <div className="mt-16 md:mt-0">
              <h3 className="text-2xl md:text-3xl font-bold text-black mb-2">{item.title}</h3>
              <p className="text-black mb-4 font-medium">{item.desc}</p>
              <ul className="space-y-2 flex flex-col items-end">
                {item.points.map((point, i) => (
                  <li key={i} className="flex flex-row-reverse items-start gap-2 text-black">
                    <FaCheck className="mt-1 flex-shrink-0" /> {point}
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>

        {/* Right Side Container */}
        <div className={`px-6 md:px-12 flex flex-col ${!isEven ? "md:items-start md:text-left" : "hidden md:block opacity-0"}`}>
          {!isEven && (
            <div className="mt-16 md:mt-0">
              <h3 className="text-2xl md:text-3xl font-bold text-black mb-2">{item.title}</h3>
              <p className="text-black mb-4 font-medium">{item.desc}</p>
              <ul className="space-y-2 flex flex-col items-start">
                {item.points.map((point, i) => (
                  <li key={i} className="flex items-start gap-2 text-black">
                    <FaCheck className="mt-1 flex-shrink-0" /> {point}
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>

      </div>
    </div>
  );
})} 
      </div>

      
      <div className="bg-[#F6AE1B] py-20 px-6 md:px-12 lg:px-20">
        <div className="max-w-4xl mx-auto text-center space-y-6">
          <h2 className="text-4xl md:text-5xl font-extrabold text-black">
            Our <span className="text-white">Commitment to Quality</span>
          </h2>
          <p className="text-black text-base md:text-lg leading-relaxed max-w-3xl mx-auto">
            We maintain a rigorous quality control process to ensure that every product meets the highest standards. Quality is not just a step for us — it’s the foundation of everything we do.
          </p>

          <div className="mt-12 grid gap-8 md:grid-cols-2">
            {qualityPoints.map((point, index) => (
              <div key={index} className="flex items-start gap-4 bg-[#40210F] p-6 rounded-xl shadow-lg hover:shadow-2xl transition-transform transform hover:-translate-y-2">
                <div className="flex-shrink-0 flex items-center justify-center w-12 h-12 rounded-full bg-black text-white text-2xl">
                  <FaCheckCircle />
                </div>
                <p className="text-white font-medium leading-relaxed">{point}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="bg-[#F6AE1B] py-20 px-6 md:px-12 lg:px-20">
        <div className="max-w-5xl mx-auto text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-extrabold text-black">
            How <span className="text-white">We Add Value</span>
          </h2>
          <p className="text-black text-base md:text-lg mt-4 max-w-3xl mx-auto">
            Our approach ensures that every product we deliver aligns with your business needs and brand vision.
          </p>
        </div>

        <div className="relative max-w-6xl mx-auto gap-4 flex flex-col md:flex-row items-center justify-between">
          {[
            { icon: "🏷️", text: "Brand Identity – Apparel that reflects your company’s culture and vision" },
            { icon: "💨", text: "Comfort & Performance – Breathable fabrics designed for long wear" },
            { icon: "📦", text: "Scalability – From small orders to large-scale corporate requirements" },
            { icon: "⏱️", text: "Timely Delivery – Efficient production process ensures on-time commitments" },
            { icon: "🤝", text: "Customer-Centric Support – Personalized service from consultation to after-sales" },
          ].map((item, index) => (
            <div key={index} className="flex-1 flex flex-col items-center relative">
              
              <div className="w-6 h-6 rounded-full bg-black z-10 relative"></div>

             
              {index !== 5 && (
                <div className="absolute top-2.5 left-1/2 transform -translate-x-1/2 w-0.5 h-full bg-black/30 z-0 md:h-32"></div>
              )}

              
              <div className="mt-6 bg-white p-6 rounded-xl shadow-md text-center md:max-w-xs hover:shadow-lg transition-transform transform hover:-translate-y-2">
                <div className="text-3xl mb-3">{item.icon}</div>
                <p className="text-black font-medium">{item.text}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

     
      <div className="bg-[#F6AE1B] py-20 px-6 md:px-12 lg:px-20">
        <div className="max-w-5xl mx-auto text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-extrabold text-black">
            Industries <span className="text-white">We Serve</span>
          </h2>
          <p className="text-black text-base md:text-lg mt-4 max-w-3xl mx-auto">
            We provide specialized apparel solutions tailored to a wide range of industries.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 max-w-6xl mx-auto">
          {[
            "Corporate & IT",
            "Manufacturing & Industrial",
            "Hospitality & Service",
            "Healthcare & Medical",
            "Education & Institutions",
            "Events & Promotions",
            "Retail & Lifestyle"
          ].map((industry, index) => (
            <div key={index} className="bg-[#40210F] p-6 rounded-lg shadow-sm hover:shadow-md transition-shadow text-center">
              <p className="text-white font-semibold">{industry}</p>
            </div>
          ))}
        </div>
      </div>

      
      <div className="max-w-4xl mx-auto bg-black/10 border-l-4 border-black p-8 rounded-xl shadow-md text-center mt-12">
        <h3 className="text-3xl md:text-4xl font-bold text-black mb-4">
          The <span className="text-white">Dheeram Difference</span>
        </h3>
        <p className="text-black text-base md:text-lg leading-relaxed mb-4">
          What sets us apart is our ability to combine creativity, precision, and reliability. Whether it’s a small batch of customized T-Shirts or a large-scale order of industrial uniforms, we deliver with the same commitment to quality and customer satisfaction.
        </p>
        <p className="text-black font-semibold text-lg md:text-xl">
          👉 With Dheeram Apparel Creations, your apparel isn’t just made — it’s crafted with care, built for performance, and designed to inspire confidence.
        </p>
      </div>
    </section>
  );
};

export default Whatwedo;
